import styled from 'styled-components'
import ReactLoading from 'react-loading'
const StyledReactLoading = styled(ReactLoading)`
  fill: #1b3a49;
  height: 64px;
  width: 64px;
  position: fixed;
  top: 35%;
  left: 50%;
`

export const LoadingBars = ({ color = '#1b3a49' }) => {
  return <StyledReactLoading type={'bars'} color={color} />
}
